import { Skeleton } from '@interco/inter-ui/components/Skeleton'

const DayWidgetSkeleton = () => (
  <Skeleton width="100%" height="86px" animation="pulse" style={{ borderRadius: '12px' }} />
)

export default DayWidgetSkeleton
